import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { GestionnaireOrAnimateurGuard } from '../core/guards/gestionnaire-or-animateur.guard';
import { FamilleGuard } from '../core/guards/famille.guard';
import { ModuleGuard } from '../core/guards/module.guard';
import { LiviaGuard } from '../core/guards/livia.guard';
import { APP_MODULES } from '../core/constants/app-modules.constants';

export const MEDIAS_ROUTES: Routes = [
  {
    path: 'medias/list',
    loadComponent: () => import('../features/medias/list/list.component').then(m => m.MediasListComponent),
    canActivate: [AuthGuard, GestionnaireOrAnimateurGuard, ModuleGuard],
    data: { modules: [APP_MODULES.MEDIAS] }
  },
  {
    path: 'information-campaigns/list',
    loadComponent: () =>
      import('../features/information-campaigns/list/list.component').then(m => m.InformationCampaignsListComponent),
    canActivate: [AuthGuard, GestionnaireOrAnimateurGuard, ModuleGuard],
    data: { modules: [APP_MODULES.COMMUNICATION_FAMILLES] }
  },
  {
    path: 'information-campaigns/famille',
    loadComponent: () =>
      import('../features/information-campaigns/list/list.component').then(m => m.InformationCampaignsListComponent),
    canActivate: [AuthGuard, FamilleGuard],
    data: { familleView: true },
  },
  {
    path: 'livia',
    loadComponent: () =>
      import('../features/messages/list/list.component').then(m => m.MessagesListComponent),
    canActivate: [AuthGuard, LiviaGuard],
    data: { liviaOnly: true }
  },
  {
    path: 'messages/list',
    loadComponent: () =>
      import('../features/messages/list/list.component').then(m => m.MessagesListComponent),
    canActivate: [AuthGuard, GestionnaireOrAnimateurGuard, ModuleGuard],
    data: { modules: [APP_MODULES.COMMUNICATION_FAMILLES] }
  },
  {
    path: 'messages/famille/:id',
    loadComponent: () =>
      import('../features/messages/list/list.component').then(m => m.MessagesListComponent),
    canActivate: [AuthGuard, FamilleGuard],
    data: { familleView: true }
  },
  {
    path: 'messages/famille',
    loadComponent: () =>
      import('../features/messages/list/list.component').then(m => m.MessagesListComponent),
    canActivate: [AuthGuard, FamilleGuard],
    data: { familleView: true }
  },
  {
    path: 'medias/famille',
    loadComponent: () =>
      import('../features/medias/famille/liste-media-famille.component').then(m => m.ListeMediaFamilleComponent),
    canActivate: [AuthGuard, FamilleGuard],
  },
  {
    path: 'medias/personnel/shared',
    loadComponent: () =>
      import('../features/medias/personnel/personnel-shared-media.component').then(m => m.PersonnelSharedMediaComponent),
    canActivate: [AuthGuard],
  },
];
